import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChildren,
  booleanAttribute,
  numberAttribute,
} from '@angular/core';
import { ObjectType } from '@galaxy/crm/static';
import { ScoringDefinitionInterface } from '@vendasta/crm';
import { ScoringDefinitionCardComponent } from '../card/card.component';

@Component({
  selector: 'crm-scoring-definition-section',
  templateUrl: './section.component.html',
  styleUrl: './section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ScoringDefinitionCardComponent],
})
export class ScoringDefinitionSectionComponent {
  @Input({ required: true }) scoringDefinitions?: ScoringDefinitionInterface[];
  @Output() scoringDefinitionsChange = new EventEmitter<ScoringDefinitionInterface[]>();

  @Input() objectType?: ObjectType;
  @Input({ transform: numberAttribute }) minContribution?: number;
  @Input({ transform: numberAttribute }) maxContribution?: number;
  @Input({ transform: booleanAttribute }) disabled = false;

  private _modified = false;
  @Output() modified = new EventEmitter<void>();

  @ViewChildren(ScoringDefinitionCardComponent) scoringDefinitionCards?: ScoringDefinitionCardComponent[];

  reset(): void {
    this.scoringDefinitionCards?.forEach((card) => card.reset());
    this._modified = false;
  }

  protected handleScoringDefinitionChange(index: number, value?: ScoringDefinitionInterface): void {
    if (this.scoringDefinitions?.[index]) {
      if (value === undefined) {
        this.scoringDefinitions.splice(index, 1);
      } else {
        this.scoringDefinitions[index] = value;
      }
      this.scoringDefinitionsChange.emit(this.scoringDefinitions);
    }
  }

  protected handleCardModified(): void {
    if (!this._modified) {
      this._modified = true;
      this.modified.emit();
    }
  }
}
